// // hooks/useVanta.ts - Vanta 효과를 위한 커스텀 훅
// import { useEffect, useRef } from 'react';
// // components/VantaBackground.tsx - 재사용 가능한 Vanta 컴포넌트
// import { Box, SxProps, Theme, useTheme } from '@mui/material';

// export interface VantaConfig {
//   effect?: 'HALO' | 'WAVES' | 'CLOUDS' | 'FOG' | 'BIRDS' | 'NET' | 'CELLS' | 'TRUNK';
//   mouseControls?: boolean;
//   touchControls?: boolean;
//   gyroControls?: boolean;
//   minHeight?: number;
//   minWidth?: number;
//   scale?: number;
//   scaleMobile?: number;
//   color?: string;
//   backgroundColor?: string;
//   size?: number;
//   spacing?: number;
//   opacity?: number;
//   amplitudeFactor?: number;
//   xOffset?: number;
//   yOffset?: number;
//   [key: string]: any; // 다른 Vanta 옵션들을 위한 확장성
// }

// export interface UseVantaOptions {
//   config?: VantaConfig;
//   autoResize?: boolean;
//   themeAware?: boolean; // 테마 변경에 반응할지 여부
// }

// declare global {
//   interface Window {
//     VANTA: any;
//     THREE: any;
//   }
// }

// export const useVanta = (options: UseVantaOptions = {}) => {
//   const theme = useTheme();
//   const vantaRef = useRef<HTMLDivElement>(null);
//   const vantaEffect = useRef<any>(null);
//   const scriptsLoaded = useRef<boolean>(false);

//   const { config = {}, autoResize = true, themeAware = true } = options;

//   // 기본 설정
//   const defaultConfig: VantaConfig = {
//     effect: 'HALO',
//     mouseControls: true,
//     touchControls: true,
//     gyroControls: false,
//     minHeight: 150.0,
//     minWidth: 150.0,
//     amplitudeFactor: 1.2,
//     xOffset: 0.5,
//     yOffset: -0.5,
//     size: 5.0,
//     ...config,
//   };

//   // 테마 기반 색상 설정
//   const getThemeColors = () => {
//     if (!themeAware) return {};

//     return {
//       baseColor:
//         theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.primary.darker,
//       backgroundColor: theme.palette.background.neutral,
//     };
//   };

//   const initVanta = () => {
//     if (vantaEffect.current) {
//       vantaEffect.current.destroy();
//     }

//     if (window.VANTA && vantaRef.current && defaultConfig.effect) {
//       const effectFunction = window.VANTA[defaultConfig.effect];

//       if (effectFunction) {
//         const finalConfig = {
//           el: vantaRef.current,
//           ...defaultConfig,
//           ...getThemeColors(),
//         };

//         vantaEffect.current = effectFunction(finalConfig);
//       } else {
//         console.warn(`Vanta effect "${defaultConfig.effect}" not found`);
//       }
//     }
//   };

//   //   const loadVantaScripts = async () => {
//   //     if (scriptsLoaded.current) {
//   //       initVanta();
//   //       return;
//   //     }

//   //     const loadScript = (src: string): Promise<void> => {
//   //       return new Promise((resolve, reject) => {
//   //         const script = document.createElement('script');
//   //         script.src = src;
//   //         script.onload = () => resolve();
//   //         script.onerror = reject;
//   //         document.head.appendChild(script);
//   //       });
//   //     };

//   //     try {
//   //       // Three.js 로드
//   //       if (!window.THREE) {
//   //         await loadScript('https://cdnjs.cloudflare.com/ajax/libs/three.js/r121/three.min.js');
//   //       }

//   //       // Vanta 효과별 스크립트 로드
//   //       if (!window.VANTA) {
//   //         const effectName = defaultConfig.effect?.toLowerCase() || 'halo';
//   //         await loadScript(
//   //           `https://cdn.jsdelivr.net/npm/vanta@latest/dist/vanta.${effectName}.min.js`,
//   //         );
//   //       }

//   //       scriptsLoaded.current = true;
//   //       initVanta();
//   //     } catch (error) {
//   //       console.error('Failed to load Vanta scripts:', error);
//   //     }
//   //   };

//   const loadVantaScripts = async () => {
//     if (scriptsLoaded.current) {
//       initVanta();
//       return;
//     }

//     const loadScript = (src: string): Promise<void> => {
//       return new Promise((resolve, reject) => {
//         const script = document.createElement('script');
//         script.src = src;
//         script.onload = () => resolve();
//         script.onerror = reject;
//         document.head.appendChild(script);
//       });
//     };

//     try {
//       // 1. Three.js 로드
//       if (!window.THREE) {
//         await loadScript('https://cdnjs.cloudflare.com/ajax/libs/three.js/r121/three.min.js');
//       }

//       // 2. Vanta 기본 라이브러리 로드
//       if (!window.VANTA) {
//         await loadScript('https://cdn.jsdelivr.net/npm/vanta@latest/dist/vanta.min.js');
//       }

//       // 3. 필요한 이펙트별 스크립트 로드
//       const effectName = defaultConfig.effect?.toLowerCase() || 'halo';
//       const effectKey = defaultConfig.effect || 'HALO';

//       if (window.VANTA && !window.VANTA[effectKey]) {
//         await loadScript(
//           `https://cdn.jsdelivr.net/npm/vanta@latest/dist/vanta.${effectName}.min.js`,
//         );
//       }

//       scriptsLoaded.current = true;
//       initVanta();
//     } catch (error) {
//       console.error('Failed to load Vanta scripts:', error);
//     }
//   };

//   const handleResize = () => {
//     if (vantaEffect.current && autoResize) {
//       vantaEffect.current.resize();
//     }
//   };

//   // 설정 업데이트 함수
//   const updateConfig = (newConfig: Partial<VantaConfig>) => {
//     if (vantaEffect.current) {
//       Object.keys(newConfig).forEach((key) => {
//         if (vantaEffect.current.setOptions) {
//           vantaEffect.current.setOptions({ [key]: newConfig[key] });
//         }
//       });
//     }
//   };

//   // Vanta 효과 파괴 함수
//   const destroyVanta = () => {
//     if (vantaEffect.current) {
//       vantaEffect.current.destroy();
//       vantaEffect.current = null;
//     }
//   };

//   useEffect(() => {
//     loadVantaScripts();

//     if (autoResize) {
//       window.addEventListener('resize', handleResize);
//     }

//     return () => {
//       if (autoResize) {
//         window.removeEventListener('resize', handleResize);
//       }
//       destroyVanta();
//     };
//   }, []);

//   // 테마 변경 시 다시 초기화
//   useEffect(() => {
//     if (themeAware && vantaEffect.current) {
//       initVanta();
//     }
//   }, [theme.palette.mode]);

//   return {
//     vantaRef,
//     updateConfig,
//     destroyVanta,
//     isLoaded: scriptsLoaded.current,
//   };
// };

// interface VantaBackgroundProps {
//   config?: VantaConfig;
//   sx?: SxProps<Theme>;
//   position?: 'fixed' | 'absolute' | 'relative';
//   zIndex?: number;
//   opacity?: number;
//   pointerEvents?: 'none' | 'auto';
//   children?: React.ReactNode;
// }

// export const VantaBackground: React.FC<VantaBackgroundProps> = ({
//   config,
//   sx,
//   position = 'fixed',
//   zIndex = -10,
//   opacity = 1,
//   pointerEvents = 'none',
//   children,
// }) => {
//   const { vantaRef } = useVanta({ config, themeAware: true });

//   return (
//     <>
//       <Box
//         ref={vantaRef}
//         sx={{
//           position,
//           top: 0,
//           left: 0,
//           width: '100vw',
//           height: '100vh',
//           zIndex,
//           pointerEvents,
//           opacity,
//           ...sx,
//         }}
//       />
//       {children}
//     </>
//   );
// };

// // components/VantaContainer.tsx - 컨테이너 타입 컴포넌트
// interface VantaContainerProps {
//   config?: VantaConfig;
//   sx?: SxProps<Theme>;
//   children?: React.ReactNode;
//   height?: string | number;
//   width?: string | number;
// }

// export const VantaContainer: React.FC<VantaContainerProps> = ({
//   config,
//   sx,
//   children,
//   height = 400,
//   width = '100%',
// }) => {
//   const { vantaRef } = useVanta({ config, themeAware: true });

//   return (
//     <Box
//       ref={vantaRef}
//       sx={{
//         position: 'relative',
//         height,
//         width,
//         overflow: 'hidden',
//         ...sx,
//       }}
//     >
//       {children && (
//         <Box
//           sx={{
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             zIndex: 1,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//           }}
//         >
//           {children}
//         </Box>
//       )}
//     </Box>
//   );
// };

// // utils/vantaPresets.ts - 미리 정의된 Vanta 설정들
// export const vantaPresets = {
//   hero: {
//     effect: 'HALO' as const,
//     amplitudeFactor: 1.2,
//     xOffset: 0.5,
//     yOffset: -0.5,
//     size: 5.0,
//   },

//   waves: {
//     effect: 'WAVES' as const,
//     color: 0x3f51b5,
//     shininess: 50,
//     waveHeight: 20,
//     waveSpeed: 0.5,
//   },

//   particles: {
//     effect: 'NET' as const,
//     color: 0x3f51b5,
//     backgroundColor: 0x0,
//     points: 10,
//     maxDistance: 20,
//     spacing: 15,
//   },

//   clouds: {
//     effect: 'CLOUDS' as const,
//     cloudShadows: true,
//     skyColor: 0x68b8d7,
//     cloudColor: 0xadc1de,
//     speed: 0.6,
//   },

//   birds: {
//     effect: 'BIRDS' as const,
//     color1: 0xff6b6b,
//     color2: 0x4ecdc4,
//     colorMode: 'variance',
//     birdSize: 1.5,
//     wingSpan: 20,
//     speedLimit: 5,
//     separation: 20,
//   },
// };

// export default useVanta;

// hooks/useVanta.ts
import { useEffect, useRef } from 'react';
import { Box, SxProps, Theme, useTheme } from '@mui/material';
import * as THREE from 'three';
// Vanta 효과 매핑
import BIRDS from 'vanta/dist/vanta.birds.min';
import CELLS from 'vanta/dist/vanta.cells.min';
import CLOUDS from 'vanta/dist/vanta.clouds.min';
import FOG from 'vanta/dist/vanta.fog.min';
// Vanta 효과들 import
import HALO from 'vanta/dist/vanta.halo.min';
import NET from 'vanta/dist/vanta.net.min';
import TRUNK from 'vanta/dist/vanta.trunk.min';
import WAVES from 'vanta/dist/vanta.waves.min';

export interface VantaConfig {
  effect?: 'HALO' | 'WAVES' | 'CLOUDS' | 'FOG' | 'BIRDS' | 'NET' | 'CELLS' | 'TRUNK';
  mouseControls?: boolean;
  touchControls?: boolean;
  gyroControls?: boolean;
  minHeight?: number;
  minWidth?: number;
  scale?: number;
  scaleMobile?: number;
  color?: string;
  backgroundColor?: string;
  size?: number;
  spacing?: number;
  opacity?: number;
  amplitudeFactor?: number;
  xOffset?: number;
  yOffset?: number;
  [key: string]: any;
}

export interface UseVantaOptions {
  config?: VantaConfig;
  autoResize?: boolean;
  themeAware?: boolean;
}
// Vanta 효과 매핑
const VANTA_EFFECTS = {
  HALO,
  WAVES,
  CLOUDS,
  FOG,
  BIRDS,
  NET,
  CELLS,
  TRUNK,
};

export const useVanta = (options: UseVantaOptions = {}) => {
  const theme = useTheme();
  const vantaRef = useRef<HTMLDivElement>(null);
  const vantaEffect = useRef<any>(null);

  const { config = {}, autoResize = true, themeAware = true } = options;

  // 기본 설정
  const defaultConfig: VantaConfig = {
    effect: 'HALO',
    mouseControls: true,
    touchControls: true,
    gyroControls: false,
    minHeight: 150.0,
    minWidth: 150.0,
    amplitudeFactor: 1.2,
    xOffset: 0.5,
    yOffset: -0.5,
    size: 5.0,
    ...config,
  };

  // 테마 기반 색상 설정
  const getThemeColors = () => {
    if (!themeAware) return {};

    return {
      baseColor:
        theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.primary.darker,
      backgroundColor: theme.palette.background.neutral,
    };
  };

  const initVanta = () => {
    if (vantaEffect.current) {
      vantaEffect.current.destroy();
      vantaEffect.current = null;
    }

    if (vantaRef.current && defaultConfig.effect) {
      const effectFunction = VANTA_EFFECTS[defaultConfig.effect];

      if (effectFunction) {
        try {
          const finalConfig = {
            el: vantaRef.current,
            THREE: THREE, // THREE.js를 명시적으로 전달
            ...defaultConfig,
            ...getThemeColors(),
          };

          vantaEffect.current = effectFunction(finalConfig);
        } catch (error) {
          console.error(`Failed to initialize Vanta effect "${defaultConfig.effect}":`, error);
        }
      } else {
        console.warn(`Vanta effect "${defaultConfig.effect}" not found`);
      }
    }
  };

  const handleResize = () => {
    if (vantaEffect.current && autoResize) {
      vantaEffect.current.resize();
    }
  };

  // 설정 업데이트 함수
  const updateConfig = (newConfig: Partial<VantaConfig>) => {
    if (vantaEffect.current) {
      Object.keys(newConfig).forEach((key) => {
        if (vantaEffect.current.setOptions) {
          vantaEffect.current.setOptions({ [key]: newConfig[key] });
        }
      });
    }
  };

  // Vanta 효과 파괴 함수
  const destroyVanta = () => {
    if (vantaEffect.current) {
      vantaEffect.current.destroy();
      vantaEffect.current = null;
    }
  };

  useEffect(() => {
    // 약간의 지연 후 초기화 (DOM이 완전히 준비되도록)
    const timer = setTimeout(() => {
      initVanta();
    }, 100);

    if (autoResize) {
      window.addEventListener('resize', handleResize);
    }

    return () => {
      clearTimeout(timer);
      if (autoResize) {
        window.removeEventListener('resize', handleResize);
      }
      destroyVanta();
    };
  }, []);

  // 테마 변경 시 다시 초기화
  useEffect(() => {
    if (themeAware && vantaEffect.current) {
      initVanta();
    }
  }, [theme.palette.mode]);

  return {
    vantaRef,
    updateConfig,
    destroyVanta,
    isLoaded: true, // npm 패키지는 항상 로드됨
  };
};

// VantaBackground 컴포넌트
interface VantaBackgroundProps {
  config?: VantaConfig;
  sx?: SxProps<Theme>;
  position?: 'fixed' | 'absolute' | 'relative';
  zIndex?: number;
  opacity?: number;
  pointerEvents?: 'none' | 'auto';
  children?: React.ReactNode;
}

export const VantaBackground: React.FC<VantaBackgroundProps> = ({
  config,
  sx,
  position = 'fixed',
  zIndex = -10,
  opacity = 1,
  pointerEvents = 'none',
  children,
}) => {
  const { vantaRef } = useVanta({ config, themeAware: true });

  return (
    <>
      <Box
        ref={vantaRef}
        sx={{
          position,
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex,
          pointerEvents,
          opacity,
          ...sx,
        }}
      />
      {children}
    </>
  );
};

// VantaContainer 컴포넌트
interface VantaContainerProps {
  config?: VantaConfig;
  sx?: SxProps<Theme>;
  children?: React.ReactNode;
  height?: string | number;
  width?: string | number;
}

export const VantaContainer: React.FC<VantaContainerProps> = ({
  config,
  sx,
  children,
  height = 400,
  width = '100%',
}) => {
  const { vantaRef } = useVanta({ config, themeAware: true });

  return (
    <Box
      ref={vantaRef}
      sx={{
        position: 'relative',
        height,
        width,
        overflow: 'hidden',
        ...sx,
      }}
    >
      {children && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  );
};

// Vanta 프리셋
export const vantaPresets = {
  halo: {
    effect: 'HALO' as const,
    amplitudeFactor: 1.2,
    xOffset: 0.5,
    yOffset: -0.5,
    size: 5.0,
  },

  waves: {
    effect: 'WAVES' as const,
    color: 0x3f51b5,
    shininess: 50,
    waveHeight: 20,
    waveSpeed: 0.5,
  },

  net: {
    effect: 'NET' as const,
    color: 0x3f51b5,
    backgroundColor: 0x0,
    points: 10,
    maxDistance: 20,
    spacing: 15,
  },

  clouds: {
    effect: 'CLOUDS' as const,
    cloudShadows: true,
    skyColor: 0x68b8d7,
    cloudColor: 0xadc1de,
    speed: 0.6,
  },

  birds: {
    effect: 'BIRDS' as const,
    color1: 0xff6b6b,
    color2: 0x4ecdc4,
    colorMode: 'variance',
    birdSize: 1.5,
    wingSpan: 20,
    speedLimit: 5,
    separation: 20,
  },
};

export default useVanta;
